import Image from 'next/image';
import {MdOutlineBusiness} from 'react-icons/md';
import {COLOR_BLACK_3} from '../../../../../config/constants/colorCodes';
import type {Company} from '../../../../../core/repositories/companyRepository';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {useMediaQuery} from '../../../../../shared/services/useMediaQuery';
import {SectionTitle} from './SectionTitle';

type Props = {
  companyName?: string;
  sameIndustryCompanies: Company[];
};

export const SameIndustryCompanies: React.FC<Props> = ({
  companyName,
  sameIndustryCompanies,
}) => {
  const {isPC} = useMediaQuery();

  if (companyName === null || sameIndustryCompanies.length === 0) {
    return null;
  }

  return (
    <div className="mt-16">
      <SectionTitle id="group_companies" sectionTitle="同じ業界の他の企業" />
      <ul className="">
        {sameIndustryCompanies.map((company) => {
          return (
            <li
              key={company.id}
              className="flex pc:gap-16 gap-8 mt-8 bg-white text-black rounded-16 p-16 items-center"
            >
              <div className="pc:w-[160px] pc:h-[100px] w-[64px] h-[40px] flex items-center justify-center">
                {company.pageType !== 'study' && company.logoURLs['400x300'] ? (
                  <Image
                    src={company.logoURLs['400x300']}
                    alt={`${company.name}のロゴ画像`}
                    width={isPC ? 160 : 64}
                    height={isPC ? 100 : 40}
                    style={{objectFit: 'cover'}}
                  />
                ) : (
                  <MdOutlineBusiness size={28} color={COLOR_BLACK_3} />
                )}
              </div>
              <div className="flex flex-col pc:flex-row gap-8 w-full">
                <div className="grow flex items-center">
                  <div className="">
                    <div className="py-4">
                      <span className="text-sm border border-black-3 text-black-3 rounded-16 px-8 py-4">
                        {company.industry}
                      </span>
                    </div>
                    <div className="px:text-xl text-lg font-bold mt-4">
                      {company.name}
                    </div>
                  </div>
                </div>
                <div className="flex gap-8 items-center w-full pc:w-auto">
                  <div className="h-36 w-full pc:w-auto flex text-sm pc:text-base text-white bg-primary-1 border border-primary rounded-full font-bold px-8 pc:px-16 pc:py-[10px] hover:opacity-50 justify-center items-center">
                    <CommonLink href={`/company/${company.id}`}>
                      <div>企業ページをみる</div>
                    </CommonLink>
                  </div>
                  <div className="h-36 w-full pc:w-auto flex text-sm pc:text-base text-primary-1 border-[2px] border-primary rounded-full font-bold px- 8 pc:px-16 pc:py-[10px] hover:opacity-50 justify-center items-center">
                    <CommonLink
                      href={`/company/${company.id}/experiences`}
                      target="_blank"
                    >
                      <div>ES・体験記をみる</div>
                    </CommonLink>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
